var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCircleMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  className: "dark:fill-jet-black-100 fill-white-100"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "dark:fill-jet-black-100 fill-coal-250"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4313 11C17.0857 11 17.6212 11.5354 17.6212 12.1899C17.6212 12.8443 17.0857 13.3797 16.4313 13.3797C15.7769 13.3797 15.2415 12.8443 15.2415 12.1899C15.2415 11.5354 15.7769 11 16.4313 11Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8033 11C12.4577 11 12.9931 11.5354 12.9931 12.1899C12.9931 12.8443 12.4577 13.3797 11.8033 13.3797C11.1488 13.3797 10.6134 12.8443 10.6134 12.1899C10.6134 11.5354 11.1488 11 11.8033 11Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.18987 11C7.84429 11 8.37973 11.5354 8.37973 12.1899C8.37973 12.8443 7.84429 13.3797 7.18987 13.3797C6.53544 13.3797 6 12.8443 6 12.1899C6 11.5354 6.53544 11 7.18987 11Z"
}))));
export default SvgIconCircleMore;